import { ReactNode, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { EditIcon } from "../../../ui/icons/edit";
import { TrashIcon } from "../../../ui/icons/trash";
import { Banner } from "../../../ui/organisms/banner";
import {  formatterDate, optionsFormatter, ReportingTypologyOption } from "../../../utils";
import { GetAllReportings, ReportingDelete, resetReportingDeleteStatus, setReportingIdToUpdate, setReportingStateReportingId, setUpdateReportingCustomerOtherODC, setUpdateReportingDetails, setUpdateReportingEntryProtocolId, setUpdateReportingNote, setUpdateReportingReportingDate, setUpdateReportingReportingState, setUpdateReportingReportingType, setUpdateReportingSender } from "./slice";
import { ReportingDTO } from "./dataService/dto";
import { useNavigate } from "react-router-dom";
import { handleState } from "./utils";
import { Alert } from "../../../ui/organisms/alert";
import Button from "../../../ui/molecules/button";

export function CustomerList() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const reportingState = useAppSelector(state => state.reporting)
    const sessionState = useAppSelector(state => state.session)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const [repToDelete, setRepToDelete] = useState<string | null>(null)

    const handleOnEdit = (data: ReportingDTO) => {
        dispatch(setReportingIdToUpdate(data.id))
        dispatch(setReportingStateReportingId(data.id))
        dispatch(setUpdateReportingReportingDate(data.reportingDate))
        dispatch(setUpdateReportingSender(data.sender))
        dispatch(setUpdateReportingCustomerOtherODC(data.customerOtherODC))
        dispatch(setUpdateReportingEntryProtocolId(data.entryProtocolId))
        dispatch(setUpdateReportingReportingState(data.reportingState))
        dispatch(setUpdateReportingReportingType(data.reportingType))
        dispatch(setUpdateReportingDetails(data.details))
        dispatch(setUpdateReportingNote(data.note))

        navigate('/editSegnalazione')
    }

    useEffect(() => {
        dispatch(GetAllReportings({ itemsPerPage: 0, page: 0, customerId: sessionState.selected.customerId! }))
    }, [])

    useEffect(() => {
        if (reportingState.reportingDeleteStatus === 'successfully') {
            dispatch(resetReportingDeleteStatus())
            dispatch(GetAllReportings({ itemsPerPage: 0, page: 0, customerId: sessionState.selected.customerId! }))
        }
    }, [reportingState.reportingDeleteStatus])

    if (sessionState.selected.customerId) {
        return (
            <div className="w-full p-4">
                {/* <div className="pb-5">
                    <ClientBanner
                        region={sessionState.selected.customerRegion!}
                        client={sessionState.selected.customerName!}
                        code={sessionState.selected.customerCode!}
                        activity={sessionState.selected.customerActivities ? `${sessionState.selected.customerActivities.map(act => optionsFormatter(act, attivita_bio))}` : undefined}
                        norm={optionsFormatter(sessionState.selected.customerNorm!, normativa)!}
                    />
                </div> */}

                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                    <table className="w-full border-collapse text-sm">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl"></th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data segnalazione</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Mittente</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cliente altro ODC</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo entrata</th>
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap">Stato</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Funzionario</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Tipo</th>
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[60px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {(reportingState.getAllReportingsResponse?.data || []).length === 0 ? (
                                <tr>
                                    <td colSpan={10} className="px-3 py-4 text-center text-neutral-500 bg-white">
                                        Nessuna segnalazione trovata
                                    </td>
                                </tr>
                            ) : (
                                reportingState.getAllReportingsResponse?.data.map((rep, index) => (
                                    <tr
                                        key={index}
                                        className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2">
                                            <div className="flex items-center gap-2">
                                                <button
                                                    className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => handleOnEdit(rep)}
                                                >
                                                    <EditIcon color="orange" size={20} />
                                                    <span className="absolute bottom-full right-0 mb-1 hidden group-hover:block px-2 py-1 text-xs text-white bg-neutral-800 rounded whitespace-nowrap pointer-events-none z-10">
                                                        Modifica Segnalazione
                                                    </span>
                                                </button>
                                                <button
                                                    className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => {
                                                        setRepToDelete(rep.id)
                                                        setShowAlert(true)
                                                    }}
                                                >
                                                    <TrashIcon color="orange" size={20} />
                                                    <span className="absolute bottom-full right-0 mb-1 hidden group-hover:block px-2 py-1 text-xs text-white bg-neutral-800 rounded whitespace-nowrap pointer-events-none z-10">
                                                        Elimina Segnalazione
                                                    </span>
                                                </button>
                                            </div>
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">
                                            {formatterDate(rep.reportingDate)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {rep.sender}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {rep.customerOtherODC}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {rep.entryProtocolInfo}
                                        </td>
                                        <td className="px-3 py-2 text-center">
                                            <div className="flex justify-center">
                                                {handleState(rep.reportingState)}
                                            </div>
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {rep.officerInfo}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">
                                            {formatterDate(rep.reportingDate)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {optionsFormatter(rep.reportingType, ReportingTypologyOption)}
                                        </td>
                                        <td className="px-3 py-2"></td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
                {
                    (showAlert && repToDelete) && (
                        <Alert title="Conferma operazione" close={() => setShowAlert(false)}>
                            <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                                <div className="pb-3">
                                    <div>
                                        Sei sicuro di voler eliminare la segnalazione?
                                    </div>
                                </div>
                                <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Button
                                        variant="outline"
                                        color="dimgrey"
                                        iconPosition="off"
                                        label="Annulla"
                                        size="md"
                                        onClick={() => setShowAlert(false)}
                                    />
                                    <div className="pl-8">
                                        <Button
                                            variant="solid"
                                            color="orange"
                                            iconPosition="off"
                                            label="Elimina"
                                            size="md"
                                            onClick={() => {
                                                dispatch(ReportingDelete(repToDelete))
                                                setShowAlert(false)
                                            }}
                                        />
                                    </div>
                                </div>

                            </div>
                        </Alert>
                    )
                }
            </div>
        )
    }

    return (
        <div className="w-full p-4">
            <Banner
                type="error"
                visible={!sessionState.selected.customerId}
                label={"Devi prima selezionare un cliente per accedere all'area"}
                closeAction={function (): void {
                    alert("Devi prima selezionare un cliente per accedere all'area")
                }}
            />
        </div>
    )
}